import React from 'react'
import { Link } from 'gatsby'
import { Layout, Header, Intro } from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            The card component is now the{' '}
            <Link className="link" to="/mt/patterns/attention-card/design">
              Attention Card
            </Link>{' '}
            pattern. Visit that page for more info.
          </p>
        </Intro>
      </Layout>
    </>
  )
}
